var map = {
	"./countries-regions-de": 99888,
	"./countries-regions-de.json": 99888,
	"./countries-regions-en": 40765,
	"./countries-regions-en.json": 40765,
	"./countries-regions-es": 23407,
	"./countries-regions-es.json": 23407,
	"./countries-regions-fr": 56704,
	"./countries-regions-fr.json": 56704,
	"./countries-regions-nl": 12841,
	"./countries-regions-nl.json": 12841,
	"./countries-regions-pl": 23613,
	"./countries-regions-pl.json": 23613,
	"./countries-regions-zh-cn": 60405,
	"./countries-regions-zh-cn.json": 60405,
	"./countries-regions-zh-tw": 67781,
	"./countries-regions-zh-tw.json": 67781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36807;